export default __webpack_public_path__ + "static/media/Category-Protein__1_.039a61ea.jpg";